import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useUseOfProceedsSection from './useUseOfProceedsSection';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const UseOfProceeds = () => {
  const {
    items,
    selectedValues,
    isAllSelected,
    isIndeterminate,
    toggle,
    toggleAll,
    isExcludedEnabled,
    onChangeExclude,
  } = useUseOfProceedsSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.UseOfProceeds }
      header={ (
        <FilterSectionHeader
          title="USE OF PROCEEDS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="uopFiltersAllCheckbox"
            />
          ) }
          rightSlot={ (
            <Checkbox
              checked={ isExcludedEnabled }
              onChange={ onChangeExclude }
              dataTest="uopExcludedCheckbox"
              label="Exclude selected"
            />
          ) }
        />
      ) }
    >
      <div className={ styles.columns2 }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-uop-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default UseOfProceeds;
